import cx from 'classnames'
import { ButtonHTMLAttributes, useId } from 'react'

import {
  ButtonVariant,
  ButtonColor,
  ButtonSize,
  SizeClassMap,
  getBaseClasses,
  colorClasses,
} from '@components/buttons/button'
import Icon, { IconName } from '@components/icon'

const sizeClasses: SizeClassMap = {
  default: '',
  small: 'p-2 text-sm',
  'normal-small': 'p-2 text-base',
  normal: 'p-3 text-lg',
  large: 'p-4 text-xl',
}

interface IconButtonProps {
  icon: IconName
  variant?: ButtonVariant
  size?: ButtonSize
  color?: ButtonColor
}

const IconButton = ({
  icon,
  variant,
  size = 'normal',
  color = 'default',
  className,
  onClick,
  disabled,
  type,
}: IconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>) => {
  const id = useId()

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cx(
        getBaseClasses(variant),
        variant ? colorClasses[variant][color] : '',
        sizeClasses[size],
        'drop-shadow-lg',
        className,
      )}
    >
      <Icon id={`button-icon-${id}`} name={icon} />
    </button>
  )
}

export default IconButton
